<template>
  <div class="thank-you-wrapper">
    <div class="card">
      <div class="icon">✓</div>

      <h1>Ευχαριστούμε!</h1>
      <p class="subtitle">
        Η πληρωμή σας ολοκληρώθηκε με επιτυχία.
      </p>

      <p class="info">
        Τα εισιτήριά σας είναι έτοιμα. Μπορείτε να τα δείτε πατώντας το κουμπί παρακάτω.
      </p>

      <RouterLink to="/tickets">
        <button>ΕΙΣΗΤΗΡΙΑ</button>
      </RouterLink>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.thank-you-wrapper {
  min-height: calc(100vh - 135px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa, #e4ecf5);
  padding: 1rem;
}

.card {
  background: #fff;
  max-width: 450px;
  width: 100%;
  padding: 3rem 2rem;
  border-radius: 16px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 1.5rem;
  border-radius: 50%;
  background: #4caf50;
  color: #fff;
  font-size: 32px;
  line-height: 60px;
  font-weight: bold;
}

h1 {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  color: #1f2933;
}

.subtitle {
  font-size: 1.05rem;
  color: #374151;
  margin-bottom: 1rem;
}

.info {
  font-size: 0.95rem;
  color: #6b7280;
  margin-bottom: 2rem;
}

button {
  width: 80%;
  border: none;
  border-radius: 20px;
  padding: 10px 0;
  font-size: 0.95rem;
  font-weight: 700;
  background: #af0036;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
}

button:hover {
  background: #870029;
}

@media (max-width: 576px) {
  .thank-you-wrapper {
    min-height: calc(100vh - 178px);
  }
}
</style>
